import type { SensitiveValue } from "./propertyValueResource";
import type { ResourceWithId } from "./resource";
import type { SpaceScopedResource, TenantedDeploymentMode } from ".";

export interface Certificate {
    SubjectDistinguishedName?: string;
    IssuerDistinguishedName?: string;
    Thumbprint?: string;
    NotAfter?: string;
    NotBefore?: string;
    Version?: number;
    SerialNumber?: string;
    SignatureAlgorithmName?: string;
    IsExpired?: boolean;
}

export interface CertificateResource extends ResourceWithId, Certificate, SpaceScopedResource {
    Name: string;
    Notes?: string;
    CertificateData: SensitiveValue;
    Password: SensitiveValue;
    EnvironmentIds: string[];
    TenantIds: string[];
    TenantTags: string[];
    CertificateDataFormat?: CertificateDataFormat;
    Archived?: string;
    ReplacedBy?: string;
    SubjectCommonName?: string;
    SubjectOrganization?: string;
    IssuerCommonName?: string;
    IssuerOrganization?: string;
    SelfSigned?: boolean;
    SelfSignedCertificateCurve?: SelfSignedCertificateCurve;
    HasPrivateKey?: boolean;
    TenantedDeploymentParticipation?: TenantedDeploymentMode;
    SubjectAlternativeNames?: string[];
    CertificateChain?: X509Certificate[];
}

export type X509Certificate = Certificate;

export enum SelfSignedCertificateCurve {
    nistP521 = "nistP521", // will cause some browsers to block access
    nistP384 = "nistP384",
    nistP256 = "nistP256",
}

export enum CertificateDataFormat {
    Pkcs12 = "Pkcs12",
    Der = "Der",
    Pem = "Pem",
    Unknown = "Unknown",
}

export enum CertificateExportPemOptions {
    PrimaryOnly = "PrimaryOnly",
    PrimaryAndChain = "PrimaryAndChain",
    ChainOnly = "ChainOnly",
}
